import React, { Fragment, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "services/interceptor/Interceptor";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import FormSection from "components/sales/formSection/formSection";
import localization from "assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ButtonWithIcon from "components/sales/buttons/buttonWithIcon/buttonWithIcon";
import { handleValidateObj } from "constants/objValues/objvalues";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import Inventory from "components/sales/inventory/inventory";
import { DatePickerInput } from "rc-datepicker";
import { Button, FormGroup } from "react-bootstrap";
import FileUpload from "components/sales/fileUpload/fileUpload";
import {
  documentUploadUrl,
  documentUploadUrlPublic,
} from "services/redux/fileUpload/action";
import * as moment from "moment";
import s from "components/sales/paymentPortal/addAdvance/addAdvance.module.css";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Config from "services/config/config";
import { Toast } from "bootstrap";
import { showToast } from "services/utils/networks/network";
import AppNotifications from "components/sales/appNotifications/appNotifications";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Images from "../../../assets/images/imageData";
import { Link } from "react-router-dom";
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import "./Modify.css";

const RaiseClaim = ({
  showRaisePopup,
  businessList,
  onClosePopup = () => {},
  documentUploadUrl,
  paymentReference,
  modeOfCollection,
  unclaimedAmount,
  match,
  history,
  unclaimedId,
  verifyInvoiceNumbers,
  editClientDetails,
  documentUploadUrlPublic,
  documentUrlDataPublic,
}) => {
  const [inputList, setInputList] = useState({
    business_id: "1",
    remarks: "",
    attachments: "",
  });
  const [isFocus1, setIsFous1] = useState(true);
  const [invoice, setInvoice] = useState([
    { document_type: "", invoice_number: "", amount: "", tds: "" },
  ]);
  const [invoiceData, setInvoiceData] = useState();
  const [isModal, setIsModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [tanNumber, setTanNumber] = useState("");
  const [tanDocument, setTanDocument] = useState("");
  const [tanDetails, setTanDetails] = useState(false);
  const [apiResponse, setApiResponse] = useState(false);
  const [clientId, setClientId] = useState('');
  const [payData, setPayData] = useState({
    payment_mode: "",
    reference_number: "",
    status: "",
    installation_amt: 0,
    rental_charge: 0,
    tag_charge: 0,
    cartage_amt: 0,
    tds_check: "No",
    trans_amount: 0,
    tan_number: "",
    confirm_tan_number: "",
    tan_attachment: "",
  });

  const handleRemoveAll = () => {
    setInputList({
      business_id: "1",
      remarks: "",
      attachments: "",
    });
  };

  const handleDocumentDetailsRemove = () => {
    setInvoice(invoice.map(() => ({
      document_type: "",
      invoice_number: "",
      amount: "",
      tds: ""
    })));
  };

  const handleModalHide2 = () => {
    // history.push(`${baseUrl}/unclaimed-listing`);
    setIsModal(false);
  };

  const handleInputChange = (val, index, type) => {
    const list = [...invoice];
    list[index][type] = val;
    setInvoice(list);
    setApiResponse(false);
    setTanDetails(false);

  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...invoice];
    list.splice(index, 1);
    setInvoice(list);
    setApiResponse(false);
    setTanDetails(false);
    setTanNumber("");
    setTanDocument("");
    setPayData({
      tan_number: "",
      confirm_tan_number: "",
      tan_attachment: "",
    });

  };
  // handle click event of the Add button
  const handleAddClick = () => {
    setInvoice([...invoice, { document_type: "", invoice_number: "", amount: "", tds: "" }]);
    setApiResponse(false);
    setTanDetails(false);
    setTanNumber("");
    setTanDocument("");
    setPayData({
      tan_number: "",
      confirm_tan_number: "",
      tan_attachment: "",
    });
  };

  const handleDateChange = (e, name) => {
    const current_datetime = moment(e).format("YYYY-MM-DD");
    setPayData((prevPayData) => ({
      ...prevPayData,
      adv_payment_date: current_datetime,
    }));
  };

  useEffect(() => {
    if (modeOfCollection && paymentReference && unclaimedAmount) {
      var modeOfCollections = modeOfCollection.replace(/\s+/g, "");
      var status = "DEPOSITED IN BANK";
      if (modeOfCollections == "CHEQUE") {
        status = "DEPOSITED IN BANK";
      } else {
        status = "ONLINE TRANSACTION BY CLIENT";
      }
      setPayData((prevPayData) => ({
        ...prevPayData,
        payment_mode: modeOfCollections,
        reference_number: paymentReference,
        trans_amount: unclaimedAmount,
        status: status,
      }));
    }
  }, [paymentReference, modeOfCollection, unclaimedAmount]);

  async function submit() {
    setIsLoading(true);
    setDisableSubmit(true);
    let isError = false;
    let msg = "";
    // eslint-disable-next-line array-callback-return
    invoice.map((val, i) => {
      if (val?.document_type === "") {
        msg = "Document type is missing";
        isError = true;
      }
      if (val?.invoice_number === "") {
        msg = "Invoice no is missing";
        isError = true;
      }
      if (val?.amount === "") {
        msg = "Invoice amount is missing";
        isError = true;
      }
      if (val?.tds === "") {
        msg = "Invoice tds is missing";
        isError = true;
      }
    });

    if (isError) {
      toast.error(msg);
      setDisableSubmit(false);
      return false;
    }
    const isNotEmpty = handleValidateObj(inputList);
    if (isNotEmpty !== false) {
      const isInvoice = handleValidateObj(invoice);
      if (isInvoice !== false) {
        setIsLoading(true);
        const payload = {
          ...inputList,
          payment_ref_no: paymentReference,
          invoice_data: invoice,
          id: unclaimedId.toString(),
        };
        let url = Config.postSales.saveTransactionClaim;
        const { data } = await axios.post(url, payload);
        onClosePopup();
        setConfirmationModal(false);
        const failed =
          data?.status === false ||
          data?.status === 1 ||
          data?.response?.status === false;
        if (failed) {
          if (data?.message) {
            setIsLoading(false);
            toast.error(data.message);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            setIsLoading(false);
            toast.error("Some error occurred!");
            setDisableSubmit(false);
          }
        } else {
          setIsLoading(false);
          toast.success("Claim raised successfully");
          setDisableSubmit(false);
          // setTimeout(history.push(`${baseUrl}/unclaimed-listing`), 4000);
          // setTimeout(() => {
          //   window.location.reload();
          // }, 3000);
        }
        handleRemoveAll();
        setIsLoading(false);
      } else {
        setDisableSubmit(false);
        setIsLoading(false);
        toast.error("Please fill invoice number!");
      }
    } else {
      setDisableSubmit(false);
      setIsLoading(false);
      toast.error("Please fill all details!");
    }
  }

  async function submitAdvance() {
    if (
      Number(payData.trans_amount) !==
      Number(payData.installation_amt) +
        Number(payData.rental_charge) +
        Number(payData.tag_charge) +
        Number(payData.cartage_amt)
    ) {
      toast.error("Total amount must be equal to transaction amount");
    } else if (unclaimedAmount < payData.trans_amount) {
      toast.error(
        "Transaction amount should be less than or equal to unclaimed amount"
      );
    } else {
      try {
        setIsLoading(true);
        let url = Config.preSalesList.addAdvanceUnclaim;
        const payload = {
          request_id: undefined,
          business_id: null,
          invoice_id: null,
          contract_id: null,
          site_number: payData.site_number,
          payment_mode: payData.payment_mode,
          amount: payData.trans_amount,
          installation_amt: payData.installation_amt,
          cartage_amt: payData.cartage_amt,
          rental_charge: payData.rental_charge,
          tag_charge: payData.tag_charge,
          transaction_date: payData.adv_payment_date,
          bank_name: payData.bank,
          tds_check: payData.tds_check,
          tds_amt: payData.tds_amt,
          payment_photo: payData.payment_photo,
          reference_number: payData.reference_number,
          status: payData.status,
          remark: payData.remark,
        };

        const response = await axios.post(url, payload);
        if (response?.data?.status == true) {
          onClosePopup();
          toast.success("Add advance request submitted successfully");
          handleRemoveAll();
          setIsLoading(false);
        } else {
          onClosePopup();
          toast.error(response?.data?.message);
          handleRemoveAll();
          setIsLoading(false);
        }
      } catch {
        setIsLoading(false);
        toast.error("Something went wrong, Please try again");
      }
    }
  }

  const handleVerifyInvoices = async () => {
    setIsLoading(true);
    setPayData((prev) => ({
      ...prev,
      tan_number: "",
      tan_attachment: "",
    }));

    const documentPayload = {
      document_numbers: invoice.map(item => ({
        document_number: item.invoice_number,
        document_type: item.document_type
      }))
    };

    console.log(documentPayload);

    const res = await verifyInvoiceNumbers(documentPayload);

    if (res?.status === true) {
      setApiResponse(true);
      setClientId(res?.data?.client_id);
      if (res?.data?.tan_number) {
        setTanDocument(res?.data?.tan_number_document);
        setTanNumber(res?.data?.tan_number);
        setPayData((prev) => ({
          ...prev,
          tan_number: res?.data?.tan_number,
          tan_attachment: res?.data?.tan_number_document,
        }));
        setTanDetails(true);
      }
    }
    setIsLoading(false);
  };

  console.log("invoice: ", invoice)

  const handleRaiseClaim = async () => {
    if(apiResponse){
      if(!tanDetails){
        if(isTdsPresent){
          const payload = {
            client_id: clientId,
            tan_number: payData?.tan_number,
            tan_number_document: payData?.tan_attachment,
          };
          setIsLoading(false);
          const res = await editClientDetails(payload);
          if (res?.status === true) {
            setConfirmationModal(true);
          } else {
            toast.error("Something went wrong");
          }
          setIsLoading(false);
        }else {
          if(payData.tan_number != "" || payData.tan_attachment != ""){
              const payload = {
                client_id: clientId,
                tan_number: payData?.tan_number,
                tan_number_document: payData?.tan_attachment,
              };
              setIsLoading(false);
              const res = await editClientDetails(payload);
              if (res?.status === true) {
                setConfirmationModal(true);
              } else {
                toast.error("Something went wrong");
              }
              setIsLoading(false);
          }else{
            setConfirmationModal(true);
          }
        }
      }else {
        setConfirmationModal(true);
      }
    }
  };

  const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/i;

  const isTdsPresent = invoice.some((inv) => Number(inv.tds) > 0);

  const disableRaiseClaim = !apiResponse || (
    !tanDetails &&
    isTdsPresent &&
    (!payData?.tan_number?.trim() || !payData?.tan_attachment?.trim())
  );

  const advancePayment = () => {
    return (
      <div className={s.root}>
        <div className="card p-3">
          <h5 className="text-danger mb-3">
            *Please ensure all invoices belong to the same client.
          </h5>
          <div className="card-body">
            {invoice.map((x, i) => (
              <div key={i} className="row align-items-end mb-3">
                {/* Document Type */}
                <div className="col-md-3 mb-2">
                  <DropDownInput
                    data={[
                      { id: "INVOICE", name: "INVOICE" },
                      { id: "DEBITNOTE", name: "DEBITNOTE" },
                    ]}
                    label={"Document Type"}
                    required
                    value={x?.document_type}
                    getIdValue={(val) => handleInputChange(val.id, i, "document_type")}
                    isStarRequired={true}
                  />
                </div>

                {/* Invoice No */}
                <div className="col-md-3 mb-2">
                  <ConstantInput
                    label={'Invoice/Debit Note Number'}
                    type="text"
                    required
                    handleChange={(val) => handleInputChange(val, i, "invoice_number")}
                    isStarRequired={true}
                  />
                </div>

                {/* Amount */}
                <div className="col-md-3 mb-2">
                  <ConstantInput
                    label={localization.amount}
                    type="number"
                    required
                    handleChange={(val) => handleInputChange(val, i, "amount")}
                    isStarRequired={true}
                  />
                </div>

                {/* TDS Amount */}
                <div className="col-md-3 mb-2">
                  <ConstantInput
                    label={localization.tdsAmount}
                    type="number"
                    required
                    handleChange={(val) => handleInputChange(val, i, "tds")}
                    isStarRequired={true}
                  />
                </div>

                {/* Action Buttons */}
                <div className="col-12 d-flex mt-2 mb-3">
                  {invoice.length !== 1 && (
                    <button
                      onClick={() => handleRemoveClick(i)}
                      className="btn btn-danger btn-sm mr-3"
                    >
                      Remove
                    </button>
                  )}
                  {invoice.length - 1 === i && (
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={handleAddClick}
                    >
                      Add
                    </button>
                  )}
                </div>
              </div>
            ))}

            {/* Verify Button */}
            <div className="text-end mt-3">
              <button className="btn btn-outline-primary btn-sm" onClick={handleVerifyInvoices}>
                Verify Documents
              </button>
            </div>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-md-8">
            <ConstantInput
              label={localization.remark}
              type="text"
              required
              handleChange={(val) => {
                setInputList({
                  ...inputList,
                  remarks: val,
                });
              }}
              isStarRequired={true}
            />
          </div>
          <div className="col-md-4">
              <FileUpload
              id={"uploadAdvPay"}
              multiple={true}
              accept=".pdf,.png,.jpg"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) => {
                // setPayData({ ...payData, payment_photo: val.toString() })
                setInputList({
                  ...inputList,
                  attachments: val.toString(),
                });
              }}
              isStarRequired={true}
            >
              <span className="btn btn-transparent">
                {localization.uploadPaymentProof}
              </span>
            </FileUpload>
          </div>
        </div>
        {apiResponse && (
          <>
            {tanDetails ? (
              <>
                <div className="row">
                  <div className="col-md-8">
                    <ConstantInput
                      label={localization.tanNumber}
                      type="text"
                      handleChange={(val) => {
                        setPayData({
                          ...payData,
                          tan_number: val,
                        });
                      }}
                      value={tanNumber}
                      disabled={true}
                    />
                  </div>
                  <div className="col-md-4">
                    <a
                      href={tanDocument}
                      className="btn btn-primary btn-sm"
                      download
                      target="_blank"
                    >
                      Tan Proof
                    </a>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row">
                  <div className="col-md-4">
                    <ConstantInput
                      label={localization.tanNumber}
                      type="password"
                      handleChange={(val) => {
                        setPayData({
                          ...payData,
                          tan_number: val,
                        });
                      }}
                      onPaste={(e) => e.preventDefault()}
                    />
                    {payData?.tan_number &&
                      !tanRegex.test(payData?.tan_number) && (
                        <div style={{ color: "red" }}>
                          Invalid TAN number format
                        </div>
                      )}
                  </div>
                  <div className="col-md-4">
                    <ConstantInput
                      label={localization.confirmTanNumber}
                      maxLength={10}
                      handleChange={(val) => {
                        setPayData({
                          ...payData,
                          confirm_tan_number: val,
                        });
                      }}
                      onPaste={(e) => e.preventDefault()}
                    />
                    {payData?.confirm_tan_number &&
                      payData?.tan_number !== payData?.confirm_tan_number && (
                        <div style={{ color: "red" }}>
                          TAN numbers do not match
                        </div>
                      )}
                  </div>
                  <div className="col-md-4">
                    <FileUpload
                      id="docs"
                      accept=".pdf,.png,.jpg"
                      documentUploadUrl={documentUploadUrlPublic}
                      documentUrlData={documentUrlDataPublic}
                      onChange={(val) => {
                        setPayData({ ...payData, tan_attachment: val });
                      }}
                      required
                    >
                      <span className="btn btn-transparent">
                        {localization.tanAttachment}
                      </span>
                    </FileUpload>
                  </div>
                </div>
              </>
            )}
          </>
        )}
        <br />
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className={s.button}>
              <Button
                className="btn btn-primary btn-sm"
                onClick={handleRaiseClaim}
                disabled={disableSubmit || disableRaiseClaim}
                // disabled={disableSubmit}
              >
                {`Raise Claim`}
              </Button>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    );
  };

  const advancePaymentPortal = () => {
    return (
      <div className={s.root}>
        <div>
          <div>
            <div className="row">
              <div className="col-12">
                <h4>Unclaimed Amount : {unclaimedAmount}</h4>
                <br />
              </div>
              <div className="col-4">
                <ConstantInput
                  label={localization.siteNumber}
                  type="text"
                  required
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      site_number: val,
                    });
                  }}
                  isStarRequired={true}
                />
              </div>
              <div className="col-4">
                <ConstantInput
                  label={localization.transAmount}
                  type="number"
                  required
                  value={payData?.trans_amount}
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      trans_amount: val,
                    });
                  }}
                  isStarRequired={true}
                />
              </div>
              <div className="col-4">
                <FormGroup
                  className={`date custom_date_picker ${
                    isFocus1 ? "active-date" : ""
                  }`}
                >
                  <label>
                    {localization.transactionDate}
                    <span className="label-star" style={{ color: "red" }}>
                      {" "}
                      *{" "}
                    </span>
                  </label>
                  <DatePickerInput
                    onChange={(e) => handleDateChange(e, "adv_payment_date")}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    format="DD-MM-YYYY"
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                  />
                  {!isFocus1 && (
                    <label className="error date_error">
                      {localization.transactionDate}
                    </label>
                  )}
                </FormGroup>
              </div>

              <div className="col-4">
                <ConstantInput
                  label={localization.paymentMode}
                  type="text"
                  required
                  value={payData?.payment_mode}
                  isStarRequired={true}
                  disabled={true}
                />
              </div>
              <div className="col-4">
                <ConstantInput
                  label={localization.paymentReference}
                  type="text"
                  required
                  value={payData?.reference_number}
                  isStarRequired={true}
                  disabled={true}
                />
              </div>
              <div className="col-4">
                <ConstantInput
                  label={localization.status}
                  type="text"
                  required
                  value={payData?.status}
                  isStarRequired={true}
                  disabled={true}
                />
              </div>

              <div className="col-4">
                <DropDownInput
                  label="Select Bank"
                  data={[
                    {
                      id: "HDFC",
                      name: "HDFC",
                    },
                    {
                      id: "IDFC",
                      name: "IDFC",
                    },
                    {
                      id: "ICICI",
                      name: "ICICI",
                    },
                    {
                      id: "IDBI",
                      name: "IDBI",
                    },
                    {
                      id: "STANDARD_CHARTERED",
                      name: "STANDARD_CHARTERED",
                    },
                  ]}
                  required
                  errorMsg={localization.paymentMode}
                  getIdValue={(val) => {
                    setPayData({
                      ...payData,
                      bank: val.id,
                    });
                  }}
                  isStarRequired={true}
                />
              </div>

              <div className="col-4">
                <FileUpload
                  id={"uploadAdvPayData"}
                  multiple={true}
                  accept=".pdf,.png,.jpg"
                  documentUploadUrl={documentUploadUrl}
                  onChange={(val) => {
                    setPayData({ ...payData, payment_photo: val.toString() });
                  }}
                >
                  <span className="btn btn-transparent">
                    {localization.uploadPaymentProof}
                  </span>
                </FileUpload>
              </div>
              <div className="col-4">
                <ConstantInput
                  label="User Remark"
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      remark: val,
                    });
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <h4>Purpose of Payment</h4>
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <ConstantInput
                  label="Installation Amount"
                  type="number"
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      installation_amt: val,
                    });
                  }}
                  required={true}
                  isStarRequired={true}
                />
              </div>
              <div className="col-4">
                <ConstantInput
                  label="Cartage Amount"
                  type="number"
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      cartage_amt: val,
                    });
                  }}
                  required={true}
                  isStarRequired={true}
                />
              </div>
              <div className="col-4">
                <ConstantInput
                  label="Tag Amount"
                  type="number"
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      tag_charge: val,
                    });
                  }}
                  required={true}
                  isStarRequired={true}
                />
              </div>
              <div className="col-4">
                <ConstantInput
                  label="Rental Amount"
                  type="number"
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      rental_charge: val,
                    });
                  }}
                  required={true}
                  isStarRequired={true}
                />
              </div>
              <div className="col-4">
                <ConstantInput
                  type="text"
                  disabled
                  value={
                    "Total Amount:   " +
                    (
                      Number(payData?.installation_amt) +
                      Number(payData?.rental_charge) +
                      Number(payData?.tag_charge) +
                      Number(payData?.cartage_amt)
                    ).toString()
                  }
                />
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <DropDownInput
                  label={localization.tdsAmount}
                  data={[
                    { id: "Yes", name: "Yes" },
                    { id: "No", name: "No" },
                  ]}
                  required
                  errorMsg={localization.tdsAmount}
                  getIdValue={(val) => {
                    setPayData({
                      ...payData,
                      tds_check: val.id,
                    });
                  }}
                  // onChange={e => handleInputChange(e, i)}

                  isStarRequired={true}
                />
              </div>
              <div className="col-4">
                {payData?.tds_check && payData?.tds_check == "Yes" && (
                  <ConstantInput
                    label={localization.tdsAmount}
                    type="number"
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        tds_amt: val,
                      });
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className={s.button}>
                <Button
                  className="btn btn-primary btn-sm"
                  onClick={() => submitAdvance()}
                  disabled={
                    isLoading ||
                    payData.payment_mode === "" ||
                    payData.trans_amount === "" ||
                    payData.reference_number === "" ||
                    payData.transaction_date === "" ||
                    payData.status === "" ||
                    payData.bank === "" ||
                    payData.tds_check === "" ||
                    (payData.tds_check === "Yes" && payData.tds_amt === "") ||
                    payData.installation_amt === "" ||
                    payData.rental_charge === "" ||
                    payData.tag_charge === "" ||
                    payData.payment_photo === ""
                  }
                >
                  {`Submit`}
                </Button>
              </div>
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
    );
  };

  return (
    <>
      <ModalPop
        title={"Raise Claim"}
        show={showRaisePopup}
        handleModalHide={() => {
          onClosePopup();
          handleRemoveAll();
          handleDocumentDetailsRemove();
          setApiResponse(false);
          setTanDetails(false);
          setTanNumber("");
          setTanDocument("");
          setPayData({
            tan_number: "",
            confirm_tan_number: "",
            tan_attachment: "",
          });
        }}
      >
        <Fragment>
          <ul class="nav nav-tabs" id="settingsTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="edit-profile-tab"
                data-toggle="tab"
                href="#edit-profile"
                role="tab"
                aria-controls="edit-profile"
                aria-selected="true"
              >
                Unclaimed
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="emails-tab"
                data-toggle="tab"
                href="#emails"
                role="tab"
                aria-controls="emails"
                aria-selected="false"
              >
                Advance
              </a>
            </li>
          </ul>
          <div class="tab-content" id="settingsTabContent">
            <div
              class="tab-pane fade show active"
              id="edit-profile"
              role="tabpanel"
              aria-labelledby="edit-profile-tab"
            >
              <FormSection>{advancePayment()}</FormSection>
            </div>
            <div
              class="tab-pane fade"
              id="emails"
              role="tabpanel"
              aria-labelledby="emails-tab"
            >
              <p>
                {" "}
                <FormSection>{advancePaymentPortal()}</FormSection>
              </p>
            </div>
          </div>
        </Fragment>
      </ModalPop>

      <ModalPop
        title={"Please Confirm Your Raise Claim"}
        show={confirmationModal}
        handleModalHide={() => {
          setConfirmationModal(false);
        }}
      >
        <Fragment>
          <FormSection>
            <div className={s.root}>
              <div>
              {invoice.map((x, i) => (
                <div key={i} className="row align-items-end mb-3">
                  {/* Document Type */}
                  <div className="col-md-3 mb-2">
                    <DropDownInput
                      data={[
                        { id: "INVOICE", name: "INVOICE" },
                        { id: "DEBITNOTE", name: "DEBITNOTE" },
                      ]}
                      label={"Document Type"}
                      required
                      getValueById={x?.document_type}
                      disabled
                      isStarRequired={true}
                    />
                  </div>

                  {/* Invoice No */}
                  <div className="col-md-3 mb-2">
                    <ConstantInput
                      label={'Invoice/Debit Note Number'}
                      type="text"
                      required
                      disabled={true}
                      value={x?.invoice_number}
                      isStarRequired={true}
                    />
                  </div>

                  {/* Amount */}
                  <div className="col-md-3 mb-2">
                    <ConstantInput
                      label={localization.amount}
                      type="number"
                      required
                      disabled={true}
                      value={x?.amount}
                      isStarRequired={true}
                    />
                  </div>

                  {/* TDS Amount */}
                  <div className="col-md-3 mb-2">
                    <ConstantInput
                      label={localization.tdsAmount}
                      type="number"
                      required
                      disabled={true}
                      value={x?.tds}
                      isStarRequired={true}
                    />
                  </div>
                </div>
              ))}
                {/* {invoice.map((x, i) => {
                  return (
                    <div key={i} className="row">
                    <div className="col-md-3 mb-2">
                        <DropDownInput
                          data={[
                            { id: "INVOICE", name: "INVOICE" },
                            { id: "DEBITNOTE", name: "DEBITNOTE" },
                          ]}
                          label={"Document Type"}
                          required
                          value={x?.document_type}
                          getIdValue={(val) => handleInputChange(val.id, i, "document_type")}
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-3">
                        <ConstantInput
                          label={localization.invoiceNo}
                          type="text"
                          disabled={true}
                          value={x?.invoice_number}
                        />
                      </div>
                      <div className="col-3">
                        <ConstantInput
                          label={localization.amount}
                          type="number"
                          disabled={true}
                          value={x?.amount}
                        />
                      </div>
                      <div className="col-3">
                        <ConstantInput
                          label={localization.tdsAmount}
                          type="number"
                          disabled={true}
                          value={x?.tds}
                        />
                      </div>
                    </div>
                  );
                })} */}
                <div>
                  <div className="row">
                    <div className="col-5">
                      <ConstantInput
                        label={localization.remark}
                        type="text"
                        isStarRequired={true}
                        disabled={true}
                        value={inputList?.remarks}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="confirm-button"
                  style={{ marginBottom: "15px" }}
                >
                  <div className="col-md-6 col-sm-6">
                    <div className={s.button} style={{ width: "36%" }}>
                      <Button onClick={() => submit()}>{"Final Submit"}</Button>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className={s.button}>
                      <Button onClick={() => setConfirmationModal(false)}>
                        {"Go Back"}
                      </Button>
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </FormSection>
        </Fragment>
      </ModalPop>
    </>
  );
};
RaiseClaim.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrl,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(RaiseClaim);
